import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'

type TrainingModuleImageItemProps = {
  callbacks: { launchModalFn: () => void },
  fileName?: string,
  imageUrl?: string,
}

const TrainingModuleImageItem = (props: TrainingModuleImageItemProps) => {
  const {
    callbacks: { launchModalFn },
    fileName,
    imageUrl,
  } = props

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px solid',
        fontSize: 'small',
        justifyContent: 'space-between',
        lineHeight: 1.3,
        padding: 'large',
      }}
      onClick={() => launchModalFn()}
      showAngleIcon
    >
      {imageUrl && (
        <Image
          backgroundSize="cover"
          borderRadius={5}
          boxProps={{ border: '1px solid', borderColor: 'lineColor', marginRight: 'large' }}
          height={60}
          url={imageUrl}
          width={100}
        />
      )}

      <Box flexDirection="column">
        <Text width="fit-content">Training Module Image</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" maxWidth="80%" variant="ellipsis">
          {imageUrl ? fileName : 'Not Uploaded'}
        </Text>
      </Box>
    </ListItem>
  )
}

export default TrainingModuleImageItem
